export const BlueRectangle = () => {
  return (
    <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.44141 3.76367L19.466 16.4908" stroke="#5279F3" stroke-width="8.65463" />
    </svg>
  );
};
